import React, { ChangeEvent, Dispatch, SetStateAction, useCallback, useMemo } from 'react';
import { useNavigate } from 'react-router-dom';
import LogoImg from '@/assets/images/logo.png';
import { ConfigType } from '@/hooks/useConfig';

interface SelectBoxProps {
  data: ConfigType[];
  name: string;
  setName: Dispatch<SetStateAction<string>>;
  defaultUrl: string;
  handleModalState: () => void;
}

function SelectBox({ data, name, setName, defaultUrl, handleModalState }: SelectBoxProps) {
  const navigate = useNavigate();

  const isCommerceSwagger = useMemo(() => defaultUrl === 'https://docs.nhn-commerce.com/', [defaultUrl]);

  const onChangeSelectBox = useCallback(
    ({ target }: ChangeEvent<HTMLSelectElement>) => {
      const { value } = target;
      setName(value);
      window.scrollTo(0, 0);
      navigate(`/?url.primaryName=${value}/`);
    },
    [setName],
  );

  return (
    <>
      <div className={'outlinks'}>
        <a className={'outlinks__logo'} href="https://www.nhn-commerce.com/" target={'_blank'}>
          <img src={LogoImg} alt="NHN commerce 홈으로 가기" />
        </a>
        <div className={'outlinks__api'}>
          <a className={`api-link ${isCommerceSwagger ? 'is-active' : ''}`} href="https://docs.nhn-commerce.com/">
            NHN commerce API <span className="ico ico--arrow"></span>
          </a>
        </div>
        <div className="trigger">
          <button data-name="trigger" onClick={handleModalState}>
            (필수) API 호출 경로를 확인해보세요
          </button>
        </div>
        <select onChange={onChangeSelectBox} value={name}>
          {data &&
            data.map(({ name }) => (
              <option key={name} value={name}>
                {name}
              </option>
            ))}
        </select>
      </div>
    </>
  );
}

export default React.memo(SelectBox);
